import { Moon, Sun } from 'lucide-react';

import { Button }    from '@/components/ui/button';
import { useAppStore } from '@/store/app.store';

export function ThemeToggle() {
  const { theme, setTheme } = useAppStore();

  return (
    <Button
      variant="ghost"
      size="icon"
      aria-label="Cambiar tema"
      onClick={() => { setTheme(theme === 'dark' ? 'light' : 'dark'); }}
    >
      {theme === 'dark'
        ? <Sun  className="h-4 w-4" />
        : <Moon className="h-4 w-4" />
      }
    </Button>
  );
}
